import { consoleInfo, getNodes } from '@gravityforms/utils';
import google from 'google';

const el = {
	mapRoot: getNodes( 'geolocation-map-root' )[ 0 ],
};

/**
 * @function initializeMap
 * @description Initializes the Google Map to the map root element.
 *
 * @return {void}
 */
const initializeMap = () => {
	const lat = parseFloat( el.mapRoot.dataset.lat );
	const lng = parseFloat( el.mapRoot.dataset.long );

	const map = new google.maps.Map( el.mapRoot, {
		center: { lat, lng },
		zoom: 8,
	} );

	const marker = new google.maps.Marker({
		position: { lat, lng },
		map,
	});
};

/**
 * @function init
 * @description initialize map-related methods.
 *
 * @return {void}
 */
const init = () => {
	if ( ! el.mapRoot ) {
		return;
	}

	initializeMap();

	consoleInfo( 'Gravity Forms Geolocation Admin: Initialized map metabox.' );
};

export default init;